import React, { useEffect, useState } from 'react';
import './Events.css';
import { useNavigate, Link, useLoaderData } from 'react-router-dom';
import { Form, Button } from 'react-bootstrap';

import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";


export default function NewEvent() {
	const navigation = useNavigate();

	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [location, setLocation] = useState("");
	const [startDate, setStartDate] = useState(new Date(new Date().setMinutes(0,0,0)));
	const [endDate, setEndDate] = useState(new Date(new Date().setMinutes(60,0,0)));
	const [image, setImage] = useState("");
	const [file, setFile] = useState<File | undefined>(undefined);
	const [hidden, setHidden] = useState(true);

	async function onFileChange(e: React.ChangeEvent<HTMLInputElement>) {
		const file = e.target.files?.[0];
		setFile(file);
		if (!file) return;
		console.log(file);

		const res = await fetch(`${process.env.REACT_APP_API_URL}/presignedUrl`);
		const data = await res.json();

		const signedUrl = data.signedUrl;
		const imageUrl = data.imageUrl;

		await fetch(signedUrl, {
			method: 'PUT',
			body: file,
		});

		setImage(imageUrl);
	}

	function formSubmit(e: React.FormEvent<HTMLFormElement>) {
		e.preventDefault();
		onSubmit();
	}

	async function onSubmit() {
		const json = {
			title,
			description,
			location,
			startDate: startDate.toString(),
			endDate: endDate.toString(),
			imageUrl: image,
			hidden,
		};
		const res = await fetch(`${process.env.REACT_APP_API_URL}/event`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(json),
		});
		const data = await res.json();
		console.log(data);

		if (res.ok) {
			navigation('/events');
		}
	}

	return (
		<div className="NewEvent">
			<div className='container container-lg'>
				<Form onSubmit={formSubmit}>
					<Form.Group controlId="title" className="mb-3">
						<Form.Label>Title</Form.Label>
						<Form.Control type="text" placeholder="Enter title" value={title} onChange={e => setTitle(e.target.value)} />
					</Form.Group>
					<Form.Group controlId="description" className="mb-3">
						<Form.Label>Description</Form.Label>
						<Form.Control as={"textarea"} placeholder="Enter description" value={description} onChange={e => setDescription(e.target.value)} />
					</Form.Group>
					<Form.Group controlId="location" className="mb-3">
						<Form.Label>Location</Form.Label>
						<Form.Control type="text" placeholder="Enter location" value={location} onChange={e => setLocation(e.target.value)} />
					</Form.Group>
					<Form.Group controlId="startDate" className="mb-3">
						<Form.Label>Start Date</Form.Label>
						<Form.Control as={DatePicker}
							selected={startDate}
							onChange={(date: unknown) => setStartDate(new Date(date as Date))}
							showTimeInput
							dateFormat="Pp"
							required
							inline />
					</Form.Group>
					<Form.Group controlId="endDate" className="mb-3">
						<Form.Label>End Date</Form.Label>
						<Form.Control as={DatePicker}
							selected={endDate}
							onChange={(date: unknown) => setEndDate(new Date(date as Date))}
							showTimeInput
							dateFormat="Pp"
							required
							inline />
					</Form.Group>
					<Form.Group controlId="image" className="mb-3">
						<Form.Label>Image</Form.Label>
						<img width={400} src={image} alt={title} />
						<Form.Control type="file" onChange={onFileChange} />
					</Form.Group>
					<Form.Group controlId="hidden" className="mb-3" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
						<Form.Label>Hidden</Form.Label>
						<Form.Check
							type={'checkbox'}
							label={`Hidden`}
							checked={hidden}
							onChange={(e) => setHidden(e.target.checked)}
						/>
					</Form.Group>
					<Button variant="primary" type="submit">
						Create
					</Button>
				</Form>
			</div>
		</div>
	);
}
